<template>
  <v-container grid-list-sm>
    <v-layout>
      <v-flex>
        <v-card :color="$store.state.sysBackgroundColor">
          <EncabezadoCrud :titulo="titulo" :accion="accion" @ejecutarAccion="ejecutarAccion" />
          <v-card-text>
            <v-form ref="form">
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-text-field ref="controlFoco" label="Nombre*" v-model="itemActivo.Nombre"
                    :rules="[rules.requerido, rules.maximo50]" :readonly="controlSoloLectura"></v-text-field>
                </v-flex>
                <v-flex xs12 md3 offset-md3>
                  <v-text-field label="Código de Barras" v-model="itemActivo.CodigoBarras" :rules="[rules.maximo15]"
                    :readonly="controlSoloLectura"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <SelectMarca :model="itemActivo.Id_Marca" :rules="[rules.requerido]" :readonly="controlSoloLectura"
                    @seleccionarItem="item => (itemActivo.Id_Marca = item.Id_Marca)
                      " />
                </v-flex>
                <v-flex xs12 md3>
                  <SelectRubro :model="itemActivo.Id_Rubro" :rules="[rules.requerido]" :readonly="controlSoloLectura"
                    @seleccionarItem="item => (itemActivo.Id_Rubro = item.Id_Rubro)
                      " />
                </v-flex>
                <v-flex xs12 md3>
                  <SelectSubrubro :model="itemActivo.Id_Subrubro" :Id_Rubro="itemActivo.Id_Rubro"
                    :rules="[rules.requerido]" :readonly="controlSoloLectura" @seleccionarItem="item => (itemActivo.Id_Subrubro = item.Id_Subrubro)
                      " />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md2>
                  <Importe2 label="Costo" v-model="itemActivo.Costo" :readonly="controlSoloLectura"
                    @seleccionarItem="sugerirContado" />
                </v-flex>
                <v-flex xs12 md2>
                  <Importe2 label="Contado" v-model="itemActivo.Contado" :readonly="controlSoloLectura"
                    @seleccionarItem="sugerirCuenta" />
                </v-flex>
                <v-flex xs12 md2>
                  <Importe2 label="A Cuenta" v-model="itemActivo.Cuenta" :readonly="controlSoloLectura" @seleccionarItem="item => (itemActivo.Cuenta = item.Importe)
                    " />
                </v-flex>
                <v-flex xs12 md2>
                  <v-text-field label="Impuestos Internos" v-model="itemActivo.ImpuestoInterno"
                    :readonly="controlSoloLectura" hint="ICL" persistent-hint></v-text-field>
                </v-flex>
                <v-flex xs12 md2>
                  <v-text-field label="Tasa A" v-model="itemActivo.TasaA" :readonly="controlSoloLectura" hint="IDC"
                    persistent-hint></v-text-field>
                </v-flex>
                <v-flex xs12 md2>
                  <Fecha label="Actualizado" :fecha="itemActivo.FechaCambioPrecio" :readonly="true" />
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 md3>
                  <SelectTipoVentaArticulo :model="itemActivo.Id_TipoVentaArticulo" :rules="[rules.requerido]"
                    :readonly="controlSoloLectura" @seleccionarItem="item =>
                      (itemActivo.Id_TipoVentaArticulo =
                        item.Id_TipoVentaArticulo)
                      " />
                </v-flex>
                <v-flex xs12 md3 offset-md3>
                  <SelectTipoIvaArticulo :model="itemActivo.Id_TipoIvaArticulo" :rules="[rules.requerido]"
                    :readonly="controlSoloLectura" @seleccionarItem="item =>
                      (itemActivo.Id_TipoIvaArticulo =
                        item.Id_TipoIvaArticulo)
                      " />
                </v-flex>
                <v-flex xs12 md3>
                  <SelectRubroIb :model="itemActivo.Id_RubroIb" :rules="[rules.requerido]" :readonly="controlSoloLectura"
                    @seleccionarItem="item => (itemActivo.Id_RubroIb = item.Id_RubroIb)
                      " />
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <PieCrud :loading="loading" />
        </v-card>
      </v-flex>
    </v-layout>
    <GrillaCrud :activo="grillaActivo" :columnas="grillaColumnas" :itemsDB="grillaItems" :loading="loading"
      @ejecutarAccion="grillaEjecutarAccion" @editarItem="grillaEditarItem" @borrarItem="grillaBorrarItem" />
    <Mensaje :activo="mensajeActivo" :tipo="mensajeTipo" :titulo="mensajeTitulo" :detalle="mensajeDetalle"
      @ejecutarAccion="ejecutarAccion" />
  </v-container>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import { eventBus } from "@/main";
import EncabezadoCrud from "@/components/EncabezadoCrud";
import PieCrud from "@/components/PieCrud";
import GrillaCrud from "@/components/GrillaCrud";
import Mensaje from "@/components/Mensaje";
import Fecha from "@/components/Fecha";
import Importe2 from "@/components/Importe2";
import SelectRubro from "@/components/Stock/SelectRubro";
import SelectSubrubro from "@/components/Stock/SelectSubrubro";
import SelectMarca from "@/components/Stock/SelectMarca";
import SelectTipoVentaArticulo from "@/components/Stock/SelectTipoVentaArticulo";
import SelectTipoIvaArticulo from "@/components/Stock/SelectTipoIvaArticulo";
import SelectRubroIb from "@/components/Stock/SelectRubroIb";
export default {
  name: "ArticuloCrud",
  components: {
    EncabezadoCrud,
    PieCrud,
    GrillaCrud,
    Mensaje,
    Fecha,
    Importe2,
    SelectRubro,
    SelectSubrubro,
    SelectMarca,
    SelectTipoVentaArticulo,
    SelectTipoIvaArticulo,
    SelectRubroIb
  },
  data() {
    return {
      titulo: "Artículos",
      rutaApi: "Articulo/",
      itemVacio: {
        Id_Articulo: 0,
        Nombre: "",
        Id_Marca: 0,
        Id_Rubro: 0,
        Id_Subrubro: 0,
        CodigoBarras: "",
        Costo: 0,
        Contado: 0,
        Cuenta: 0,
        FechaCambioPrecio: "",
        ImpuestoInterno: "",
        TasaA: "",
        Id_TipoVentaArticulo: "U",
        Id_TipoIvaArticulo: "G",
        Id_RubroIb: 1
      },
      itemActivo: {},
      rules: {
        requerido: v => !!v || "Requerido",
        maximo50: v => (v || "").length <= 50 || "Máximo 50 caracteres",
        maximo15: v => (v || "").length <= 15 || "Máximo 15 caracteres"
      },
      grillaColumnas: [
        { text: "Nombre", value: "Nombre" },
        { text: "Barras", value: "CodigoBarras" },
        { text: "Actualizado", value: "FechaCambioPrecio", mask: "esFecha" },
        { text: "Contado", value: "Contado", mask: "esMoneda" },
        { text: "Cuenta", value: "Cuenta", mask: "esMoneda" }
      ],
      grillaItems: [],
      grillaActivo: false,
      loading: false,
      mensajeActivo: false,
      mensajeTipo: "",
      mensajeTitulo: "",
      mensajeDetalle: "",
      controlSoloLectura: true,
      accion: ""
    };
  },
  methods: {
    ejecutarAccion(accion) {
      this.accion = accion;
      switch (accion) {
        case "Nuevo":
          this.itemActivo = Object.assign({}, this.itemVacio);
          this.controlSoloLectura = false;
          setTimeout(() => {
            eventBus.$emit("inicializarFecha");
          }, 100);
          this.$refs.controlFoco.focus();
          break;
        case "Guardar":
          if (this.$refs.form.validate())
            this.mostrarMensaje(true, "ConfirmacionGuardar", null, null);
          break;
        case "AceptarConfirmacionGuardar":
          this.guardarItem(this.itemActivo);
          break;
        case "Abrir":
          this.grillaActivo = true;
          this.grillaItems = [];
          break;
        case "Editar":
          this.grillaActivo = false;
          this.controlSoloLectura = false;
          this.$refs.controlFoco.focus();
          break;
        case "Borrar":
          this.grillaActivo = false;
          this.mostrarMensaje(true, "ConfirmacionBorrar", null, null);
          break;
        case "AceptarConfirmacionBorrar":
          this.borrarItem(this.itemActivo);
          break;
        case "CancelarConfirmacionGuardar":
          this.mostrarMensaje(false);
          break;
        case "CancelarConfirmacionBorrar":
        case "CancelarError":
          this.mostrarMensaje(false);
          this.ejecutarAccion("Inicializar");
          break;
        case "Inicializar":
          this.itemActivo = Object.assign({}, this.itemVacio);
          this.controlSoloLectura = true;
          this.$refs.form.resetValidation();
          break;
      }
    },
    sugerirContado(importe) {
      this.itemActivo.Contado = this.itemActivo.Cuenta = importe;
    },
    sugerirCuenta(importe) {
      this.itemActivo.Cuenta = importe;
    },
    guardarItem(item) {
      this.loading = true;
      this.itemActivo.FechaCambioPrecio = new Date().toJSON();
      HttpHelper.post(this.rutaApi, item)
        .then(() => {
          this.ejecutarAccion("Inicializar");
          this.mostrarMensaje(false);
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    borrarItem(item) {
      this.loading = true;
      HttpHelper.delete(this.rutaApi + item.Id_Articulo)
        .then(() => {
          this.ejecutarAccion("Inicializar");
          this.mostrarMensaje(false);
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    grillaEjecutarAccion(accion, textoBuscado) {
      switch (accion) {
        case "Listar":
          this.grillaListarItems(textoBuscado);
          break;
        case "Cerrar":
          this.grillaActivo = false;
          break;
      }
    },
    grillaListarItems(textoBuscado) {
      this.loading = true;
      this.grillaItems = [];
      HttpHelper.get(this.rutaApi, {
        palabra: textoBuscado
      })
        .then(response => {
          this.grillaItems = response.data;
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    grillaEditarItem(item) {
      this.loading = true;
      HttpHelper.get(this.rutaApi, {
        id: item.Id_Articulo
      })
        .then(response => {
          this.itemActivo = Object.assign({}, response.data);
          setTimeout(() => {
            eventBus.$emit(
              "listarItemsSelectSubrubro",
              this.itemActivo.Id_Rubro
            );
          }, 100);
          this.ejecutarAccion("Editar");
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    grillaBorrarItem(item) {
      this.itemActivo = item;
      this.ejecutarAccion("Borrar");
    },
    mostrarError(error) {
      var detalle;
      detalle =
        error.response === undefined
          ? error
          : error.response.data.ExceptionMessage;
      this.mostrarMensaje(true, "Error", null, detalle);
    },
    mostrarMensaje(activo, tipo, titulo, detalle) {
      if (activo) {
        this.mensajeTipo = tipo;
        this.mensajeTitulo = titulo;
        this.mensajeDetalle = detalle;
      }
      this.mensajeActivo = activo;
    }
  }
};
</script>
